// --------------------------------------------------------
// CRIAR AGENDA HORARIO INPUT - CriarAgendaHorarioInput
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { TextField } from '@mui/material'
import InputMask from "react-input-mask";
import React, { useEffect, useState } from 'react'
import { ResponsiveContainer, Text } from '../UI/generalLayout/Layout.styled';
import { removeFieldFromList } from '../../helpers/CareLineHelperFunctions';
import { GrayText } from '../../pages/criarAgenda/CriarAgenda.styled';
import CareLineDropdown from '../dropdown/CareLineDropdown';
import Colors from '../../constants/Colors';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import { ReactComponent as TrashBin } from '../../assets/imgs/trashBin.svg'
import { insertElementIntoList } from '../../helpers/HelperFunctions';
import moment from 'moment';
import GenericModal from '../genericModal/GenericModal';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CRIAR AGENDA HORARIO INPUT INTERFACE
// --------------------------------------------------------

interface ICriarAgendaHorarioInput {
    horarios: any[];
    horario: any;
    index: number;
    setHorarioError: any;
    onChangeHorario: (event: any) => void;
    onChangeTempoConsulta: (value: any) => void;
    onTrashClick: (value: any) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CriarAgendaHorarioInput = ({ horarios, horario, index, setHorarioError, onChangeHorario, onChangeTempoConsulta, onTrashClick }: ICriarAgendaHorarioInput) => {
    // --------------------------------------------------------
    // CRIAR AGENDA HORARIO INPUT PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [tempoConsultaOptions] = useState([{ nome: '15 minutos', id: '15' }, { nome: '20 minutos', id: '20' }, { nome: '30 minutos', id: '30' }, { nome: '40 minutos', id: '40' }, { nome: '60 minutos', id: '60' }])
    const [showModalHours, setShowModalHours] = useState(false)
    const [hasAnyOverlappingTime, setOverlappingTime] = useState(false)
    const { isMobile, isDesktop } = useResponsiveInfo()

    const insertHorarioOnList = (list: any[], horario: any, index: number, isInicial: boolean) => {
        const removedList = [...list]
        const removedElement = removedList.splice(index, 1)
        const elementToInsert = {
            horarioInicial: isInicial ? horario : removedElement[0].horarioInicial,
            horarioFinal: isInicial ? removedElement[0].horarioFinal : horario,
            tempoConsulta: removedElement[0].tempoConsulta,
            inativo: false
        }
        const listaRetorno = insertElementIntoList(horarios, elementToInsert, index)
        return listaRetorno
    }

    const insertTempoConsultaOnList = (list: any[], tempoConsulta: any, index: number) => {
        const removedList = [...list]
        const removedElement = removedList.splice(index, 1)
        const elementToInsert = {
            ...removedElement[0],
            tempoConsulta: tempoConsulta
        }
        const listaRetorno = insertElementIntoList(horarios, elementToInsert, index)
        return listaRetorno
    }

    const cleanHours = () => {
        horario.horarioInicial = '';
        horario.horarioFinal = '';
    }

    useEffect(() => {
        const horarioInicial = moment(horario.horarioInicial, 'HH:mm')
        const horarioFinal = moment(horario.horarioFinal, 'HH:mm')

        if ((horario.horarioInicial.length === 5 && horario.horarioFinal.length === 5) && horarioInicial > horarioFinal) {
            setShowModalHours(true)
        }
    }, [horario])

    useEffect(() => {
        const filteredHorarios = horarios.filter(r => { return r.horarioInicial !== horario.horarioInicial && r.horarioFinal !== horario.horarioFinal })
        const hasOverlappingTime = filteredHorarios.some(h => {
            const horarioInicial = moment(horario.horarioInicial, 'HH:mm');
            const horarioFinal = moment(horario.horarioFinal, 'HH:mm');
            const horarioCheckInicial = moment(h.horarioInicial, 'HH:mm');
            const horarioCheckFinal = moment(h.horarioFinal, 'HH:mm');

            return horarioInicial.isBetween(horarioCheckInicial, horarioCheckFinal) || horarioInicial === horarioCheckInicial || horarioFinal === horarioCheckFinal
        })
        setOverlappingTime(hasOverlappingTime)

        if (hasOverlappingTime) {
            setHorarioError((prev: any) => {
                const list = [...prev]
                list.splice(index, 0, 'Erro de overlap')
                return list;
            })
        } else {
            setHorarioError((prev: any) => { return prev.splice(1, index) })
        }
    }, [horarios])

    const DropdownWithLabel = ({ label, width, onChange, value }: any) => {
        return (
            <div>
                <Text style={{ fontSize: 14, color: Colors.GRAY400 }}>{label}</Text>
                <CareLineDropdown
                    containerStyle={{ width: width, marginRight: 18 }}
                    value={value}
                    onChange={onChange}
                    items={tempoConsultaOptions}
                    disabled={false}
                />
            </div>)
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <ResponsiveContainer isMobile={!isDesktop} style={{ marginBottom: 10 }}>
                <div>
                    <GrayText>Horários de atendimento</GrayText>
                    <InputMask
                        mask="99:99"
                        onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                        maskPlaceholder="" value={horario.horarioInicial}
                        onChange={(event: any) => { onChangeHorario([...insertHorarioOnList(horarios, event.target.value, index, true)]) }}
                    >
                        <TextField error={false} style={{ marginRight: 10, width: 80 }} />
                    </InputMask>
                    <InputMask
                        mask="99:99"
                        onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                        maskPlaceholder="" value={horario.horarioFinal}
                        onChange={(event: any) => { onChangeHorario([...insertHorarioOnList(horarios, event.target.value, index, false)]) }}
                    >
                        <TextField error={false} style={{ marginRight: 10, width: 80 }} />
                    </InputMask>
                </div>
                <DropdownWithLabel
                    label="Tempo de consulta"
                    value={horario.tempoConsulta}
                    width={'95%'}
                    onChange={(value: any) => { onChangeHorario([...insertTempoConsultaOnList(horarios, value, index)]) }}
                />
                {horarios.length > 1 && (<TrashBin style={{ marginTop: 58, cursor: 'pointer' }} onClick={() => { onTrashClick([...removeFieldFromList(horarios, index)]) }} />)}
            </ResponsiveContainer>

            <GenericModal
                visible={showModalHours}
                onCancel={() => { setShowModalHours(false) }}
                onConfirm={() => { cleanHours(); setShowModalHours(false); }}
                modalTitle={`Horário fim [${horario.horarioFinal}] menor que horário de início [${horario.horarioInicial}]. Deseja prosseguir?`}
                modalSubtitle={''}
                cancelButtonMsg={'Cancelar'}
                confirmButtonMsg={'Confirmar'}
            />
        </>
    )
    // --------------------------------------------------------
}

export default CriarAgendaHorarioInput